export default __webpack_public_path__ + "static/media/gogs2.89b38a92.jpg";